import SvgIcon from '@/shared/ui/svg-icon'
import UiButton from '@/shared/ui/ui-button'
import { ModalWrapper } from '@/shared/ui/ui-confirm-modal/styled'
import UiCustomModal from '@/shared/ui/ui-modal/UiCustomModal'

interface UiConfirmDiscardDialogProps {
  open: boolean
  onOk: () => void
  onCancel: () => void
}

/**
 * Confirmation dialog shown when the user tries to close a modal
 * with unsaved form changes.
 *
 * Styled to match UiConfirmModal (ConfirmModal) design:
 * - Icon: warning-usb
 * - Title: "Xác nhận đóng"
 * - Message: "Các thay đổi chưa được lưu sẽ bị mất nếu bạn đóng."
 * - Buttons: [Tiếp tục chỉnh sửa] [Đóng]
 */
export default function UiConfirmDiscardDialog({
  open,
  onOk,
  onCancel,
}: UiConfirmDiscardDialogProps) {
  return (
    <UiCustomModal
      open={open}
      title={null}
      onCancel={onCancel}
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 12,
            paddingBottom: 'var(--vbdt-space-xs)',
          }}
        >
          <UiButton
            variant="outlined"
            onClick={onCancel}
            style={{
              padding: '0 20px',
              height: 36,
              borderRadius: 4,
              borderColor: 'var(--vbdt-color-border-default)',
            }}
          >
            Tiếp tục
          </UiButton>
          <UiButton
            onClick={onOk}
            style={{
              padding: '0 20px',
              height: 36,
              borderRadius: 4,
              background: 'var(--vbdt-color-accent-base)',
            }}
          >
            Vẫn đóng
          </UiButton>
        </div>
      }
      size="sm"
      centered
      mask={{ closable: false }}
      keyboard={false}
      closable={false}
      destroyOnHidden
    >
      <ModalWrapper
        className="d-flex justify-content-center flex-column align-items-center"
        style={{ padding: '16px 0 8px 0' }}
      >
        <div className="trashCan">
          <SvgIcon name="warning-usb" />
        </div>
        <div
          className="textTitle"
          style={{ fontSize: 18, marginBottom: 'var(--vbdt-space-xs)', textAlign: 'center' }}
        >
          Xác nhận đóng
        </div>
        <div
          className="textValue"
          style={{
            color: 'var(--vbdt-color-text-secondary)',
            textAlign: 'center',
            marginBottom: 'var(--vbdt-space-md)',
          }}
        >
          Các thay đổi chưa được lưu sẽ bị mất nếu bạn đóng.
        </div>
      </ModalWrapper>
    </UiCustomModal>
  )
}
